module.exports = __webpack_public_path__ + "img/senalando-izqmx.png.3b1f390e.webp";